import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

export const BASE_SINGLE_ARG_NUMERIC_FUNCTION = {
  category: FunctionCategory.MATH,
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'Either a column or number.',
    },
  ],
};

export const BASE_AGGREGATION = {
  category: FunctionCategory.STATS,
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'Either a column or number.',
    },
  ],
  repeatableLastParamType: ArgType.number,
  repeatableLastParamDescription: 'Additional columns or numbers.',
};
